import { render } from "./EditReturnPurchase.vue?vue&type=template&id=86350936"
import script from "./EditReturnPurchase.vue?vue&type=script&lang=js"
export * from "./EditReturnPurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__